import { css, keyframes } from '@emotion/react'
import styled from '@emotion/styled'

const bgFlashBlue = keyframes`
  0%   { background-color: #F5F5F6; }
  40%  { background-color: #DBEAFE; }
  100% { background-color: #F5F5F6; }
`

const bgFlashRed = keyframes`
  0%   { background-color: #F5F5F6; }
  40%  { background-color: #FEE2E2; }
  100% { background-color: #F5F5F6; }
`

const shakeX = keyframes`
  0%, 100% { transform: translateX(0); }
  15%  { transform: translateX(-5px); }
  30%  { transform: translateX(5px); }
  45%  { transform: translateX(-3px); }
  60%  { transform: translateX(3px); }
  75%  { transform: translateX(-1px); }
`

const quizFadeOut = keyframes`
  0%   { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-20px); }
`

export type TransitionState = 'idle' | 'correct' | 'wrong'

export const QuizContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'transitionState',
})<{ transitionState?: TransitionState }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  align-self: stretch;
  background-color: #F5F5F6;
  border: none;
  position: relative;
  overflow: hidden;

  ${({ transitionState }) =>
    transitionState === 'correct' &&
    css`
      animation:
        ${bgFlashBlue} 0.7s 0.15s ease-out,
        ${quizFadeOut} 0.4s 0.35s ease-in forwards;
    `}

  ${({ transitionState }) =>
    transitionState === 'wrong' &&
    css`
      animation:
        ${shakeX} 0.4s 0.15s ease-out,
        ${bgFlashRed} 0.7s 0.15s ease-out,
        ${quizFadeOut} 0.4s 0.4s ease-in forwards;
    `}
`

export const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  align-self: stretch;
  background-color: #ffffff;
`

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
`
